/**
 * School programmes list, optionally opening one programme in the editor.
 * @param {object} opts
 * @param {string} opts.schoolId
 * @param {string} [opts.programmeId]
 * @param {boolean} [opts.isDraft]
 * @param {string} [opts.schoolName]
 * @return {string|null}
 */
export function programmeHref({
  schoolId,
  programmeId,
  isDraft = false,
  schoolName,
}) {
  if (!schoolId) return null;
  const q = new URLSearchParams();
  q.set("isDraft", isDraft ? "true" : "false");
  if (programmeId) q.set("programme", programmeId);
  if (schoolName) q.set("school", schoolName);
  return `/school/${schoolId}/programmes?${q.toString()}`;
}
